<template>
  <List
    type="checkbox"
    :item="item" />
</template>

<script>
import List from "@/components/ui/form/List.vue"

export default {
  name: "CheckboxList",
  components: { List },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>